<!-- Action Buttons -->
<div
  class="action-buttons-section mt-4"
>
  <p-button
    type="button"
    label="Submit for Validation"
    styleClass="!max-w-[200px] !min-w-[100px] !mr-2 !bg-taxpod-blue !border-taxpod-blue !font-lato !font-bold !text-base disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
    (onClick)="onSubmit()"
    [disabled]="isSubmitting || !hasUnsavedChanges || externallyDisabled"
    [loading]="isSubmitting"
  ></p-button>

  <p-button
    label="Cancel"
    variant="text"
    styleClass="!max-w-[100px] !min-w-[50px] !border-taxpod-blue !text-taxpod-blue !border-[2px] !text-sm xlplus:!text-base hover:!bg-[#E0F2FE] disabled:!text-[#83858a] disabled:!bg-[#d5d7da] disabled:!border-[#d5d7da]"
    (onClick)="onCancel()"
    [disabled]="isSubmitting || !hasUnsavedChanges"
  ></p-button>

  <p
    *ngIf="externallyDisabled && externallyDisabledReason"
    class="mt-2 text-sm text-amber-700"
  >
    {{ externallyDisabledReason }}
  </p>
</div>

<!-- Cancel Changes Confirmation Dialog -->
<p-confirmDialog
  [closable]="false"
></p-confirmDialog>

<!--
  Self-owned error-toast outlet. Co-located here so it shares this component's
  injected MessageService instance on every host, giving the submit error toast
  the same custom-error UI as the delete toast (see onSubmit()'s tag:'error' branch).
-->
<interactive-toast [key]="'submit_for_validation_error'"></interactive-toast>
